import React, { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { CircularProgress } from "../UI/CircularProgress/CircularProgress";
import { Safearea } from "../UI/Safearea/Safearea";
import { Row, Col } from "../UI/Customstrap/Customstrap";
import { Container } from "../UI/Container/Container";
import { getAnswers } from "../../services/api/person";
import { getSession, getCurrentAccount, getSavedPersonInfo } from "../../reducers/selectors";
import redoTestIcon from "../../../public/svg/redoTest.svg";
import { Icons } from "../UI/Icon/Icon";
import style from "./ProfileTestAnswer.scss";
import GenericButton from "../UI/Button/Button";
import { ProfileTest } from "../ProfileTest/ProfileTest";
import { Prompt } from "react-router-dom";

export const ProfileTestAnswer = ({ toggleProfileAnswers }) => {
  const [start, setStart] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showRedoTest, setShowRedoTest] = useState(false);

  const profileRiskString = {
    Conservative: "Conservador",
    Moderate: "Moderado",
    Aggressive: "Agresivo",
    Aggresive: "Agresivo",
  };

  const personInfo = useSelector(getSavedPersonInfo);

  useEffect(() => {
    setLoading(() => true);
    getAnswers()
      .then(({ response }) => {
        setQuestions(response.questions);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setLoading(() => false);
      });
  }, []);

  let isEmpty = false;
  if (personInfo === null || personInfo === undefined) {
    isEmpty = true;
  } else if (Object.keys(personInfo).length === 0) {
    isEmpty = true;
  }

  const toggleShowRedoTest = () => {
    setShowRedoTest((stateRedoTest) => !stateRedoTest);
  };

  if (!personInfo || loading) return <CircularProgress />;

  return (
    <div className={style.subAssetClassDisplay}>
      <Row>
        <Col xs={12} className={style.titleWrapper}>
          <span className={style.iconWrapper} onClick={toggleProfileAnswers}>
            <Icons.ArrowLeftIcon className={style.iconArrow} />
          </span>
          <span className={style.title}>Perfil inversor</span>
        </Col>
        <hr />
      </Row>
      <Fragment>
        <Row>
          <Col>
            <Container className={style.profileContainer}>
              <div className={style.boxProfile}>
                <div className={style.icon}>
                  <Icons.ProfileIcon size="xl"></Icons.ProfileIcon>
                  <p className={style.profileType}>
                    Perfil {profileRiskString[personInfo.PersonProfileRiskName]}
                  </p>
                </div>
                <div className={style.buttonRedoTest}>
                  <GenericButton
                    label={isEmpty ? "Hacer prueba de perfil" : "Rehacer prueba"}
                    rounded
                    position={"relative"}
                    padding={"14px 20px 14px 20px"}
                    lineHeight={"28px"}
                    handleClick={toggleShowRedoTest}
                    iconSvg={[{ width: "20px", item: redoTestIcon }]}
                  ></GenericButton>
                </div>
              </div>
            </Container>
          </Col>
        </Row>
        <Row>
          <Col>
            <Container className={style.container}>
              <div>
                {isEmpty ? (
                  <div className={style.answerTitle}>
                    Para ver su perfil de inversionista primero debe hacer la prueba de perfil
                  </div>
                ) : (
                  <div>
                    <div className={style.answerTitle}>Mis respuestas</div>
                  </div>
                )}

                {questions.map((question, index) => {
                  return <Question key={index} question={question} />;
                })}
              </div>
            </Container>
          </Col>
        </Row>
      </Fragment>
      <Prompt
        when={showRedoTest}
        message={(location) => {
          toggleShowRedoTest();
          // No permitir la navegación hacia atrás
          return false;
        }}
      />
      {showRedoTest && <ProfileTest toggleRedoTest={toggleShowRedoTest} />}
    </div>
  );
};

const Question = ({ question }) => {
  const [active, setActive] = useState("");

  return (
    <form className={style.questionContainer}>
      <p className={style.questionTitle}>{question.QuestionDescription}</p>
      {question.Answer.map((answer, index) => {
        const key = `${question.QuestionId}-${index}`;

        return (
          <div key={key} className={`${style.answerRow} ${active == key ? style.answerRowActive : ""}`}>
            <span className={style.answerText}>{answer.AnswerDescription}</span>
          </div>
        );
      })}
    </form>
  );
};
